module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp23_2.e8cc8b86.png";